import React from 'react';
import PropTypes from 'prop-types';

import { getHandleAddress } from 'bento-ordering/utils/openAddress';
import PlainSecondaryCta from 'components/Buttons/PlainSecondaryCta';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const AddressLink = ({
  street,
  city,
  state,
  postalCode,
  googlePlaceId,
  handleClick,
  dataTestId
}) => {
  const styles = { variant: ITEM_DESCRIPTION_AND_PRICES };
  const processedHandleClick =
    getHandleAddress({
      street,
      city,
      state,
      postalCode,
      googlePlaceId
    }) || handleClick;

  return (
    <PlainSecondaryCta
      label={
        <MenuItemDescriptionTypography {...styles}>
          {street}, {city}, {state} {postalCode}
        </MenuItemDescriptionTypography>
      }
      handleClick={processedHandleClick}
      dataTestId={dataTestId}
    />
  );
};

AddressLink.propTypes = {
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  googlePlaceId: PropTypes.string,
  handleClick: PropTypes.func,
  dataTestId: PropTypes.string
};

AddressLink.defaultProps = {
  handleClick: () => {}
};

export default AddressLink;
